'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQs = void 0;
var transport_1 = require("../../transport");
var FAQs = /** @class */ (function () {
    function FAQs() {
    }
    FAQs.prototype.get = function (params) {
        return transport_1.transport.request('faqs/get', params);
    };
    FAQs.prototype.getByCatId = function (params) {
        return transport_1.transport.request('faqs/getByCatId', params);
    };
    return FAQs;
}());
exports.FAQs = FAQs;
